import { Endpoint } from '../endpoint';
import { CommissionResponse } from '@business/entities/commission';
import { CommissionFormData } from '@modules/settings/SettingsPage/Components/CommissionSettingsTab/CommissionTab';

export function fetchCommissions() {
  return Endpoint.get<CommissionResponse[]>(`@gc/commission`);
}

export function getErrors() {
  return Endpoint.get<string[]>(`@gc/commission/errors`);
}

export function saveCommissions(data: CommissionFormData) {
  return Endpoint.post<CommissionResponse[]>(`@gc/commission`, { data });
}

export function saveManualCommission(data: any) {
  return Endpoint.post<CommissionResponse>(`@gc/commission/manual`, { data });
}

export function updateManualCommission(id: string, data: any) {
  return Endpoint.put<CommissionResponse>(`@gc/commission/manual/${id}`, { data });
}

export function deleteManualCommission(id: string) {
  return Endpoint.delete<void>(`@gc/commission/manual/${id}`);
}

export function saveSplitOverrides(data: any) {
  return Endpoint.post<void>(`@gc/commission/split-overrides`, { data });
}

export function getSplitOverrides() {
  return Endpoint.get<any[]>(`@gc/commission/split-overrides`);
}

export function fetchDefaults() {
  return Endpoint.get<any[]>(`@gc/commission/defaults`);
}

export function saveDefaults(data: any) {
  return Endpoint.post<any[]>(`@gc/commission/defaults`, { data });
}
